import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
  GetAll,
} from "../../../../features/admin/customization/appsetup/Slice";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";

import { Offcanvas } from "react-bootstrap";

function Edit({ show, onHide, id, setShowError, setSuccess, setErr }) {
  const [modalShow, setModalShow] = React.useState(false);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    getValues,
    control,
    watch,
    formState: { errors },
    reset,
    image_required = true,
  } = useForm();
  const imageFile = watch("image");
  const advertisementimageFile = watch("advertisement_image");

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));
      if (res.meta.requestStatus === "fulfilled") {
        reset(res?.payload?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    if (id !== "") {
      GetData(id);
    }
  }, [id, show]);

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("name", data?.name);
      sendData.append("support_contact_no", data?.support_contact_no);
      // sendData.append("min_fund_deposit", data?.min_fund_deposit);
      // sendData.append("min_driver_amount", data?.min_driver_amount);
      sendData.append("interest_day", data?.interest_day);
      sendData.append("interest_percent", data?.interest_percent);
      sendData.append("interest_amount", data?.interest_amount);
      sendData.append("cab_r_i_amount", data?.cab_r_i_amount);
      sendData.append("transport_r_i_amount", data?.transport_r_i_amount);
      sendData.append("share_r_i_count", data?.share_r_i_count);
      let response;
      if (id) {
        response = await dispatch(Update({ id: id, data: sendData }));
      } else {
        response = await dispatch(Create(sendData));
      }
      if (response.meta.requestStatus === "fulfilled") {
        await dispatch(GetAll());
        setSuccess(true);
        setModalShow(true);
        setTimeout(() => {
          onHide();
          setModalShow(false);
        }, 3000);
      } else if (response.meta?.requestStatus === "rejected") {
        setShowError(response.payload?.response?.data?.errors);
      }
    } catch (error) {
      setErr(true);
      console.error("error in Add Namee", error);
    }
  };
  return (
    <Offcanvas show={show} onHide={onHide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Edit App SetUp</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="forms_section">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-lg-6 col-md-6 mb-3">
                <div className="form-group">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    name=""
                    placeholder="Name"
                    {...register("name", {
                      required: "Name is Required",
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.name,
                    })}
                  />
                  {errors.name && (
                    <span className="text-danger">{errors.name?.message}</span>
                  )}
                </div>

                <div className="form-group">
                  <Form.Label>Support Contact Number</Form.Label>
                  <Form.Control
                    type="tel"
                    placeholder="Enter Support Contact Number"
                    maxLength={10}
                    onKeyDown={(e) => {
                      if (
                        !/[0-9]/.test(e.key) &&
                        e.key !== "Backspace" &&
                        e.key !== "Delete" &&
                        e.key !== "Tab"
                      ) {
                        e.preventDefault();
                      }
                    }}
                    {...register("support_contact_no", {
                      required: "Support Contact Number is Required",
                      pattern: {
                        value: /^[6-9][0-9]{9}$/,
                        message: "Enter valid 10 digit mobile number",
                      },
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.support_contact_no,
                    })}
                  />
                  {errors.support_contact_no && (
                    <span className="text-danger">
                      {errors.support_contact_no?.message}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <Form.Label>Interest Days</Form.Label>
                  <Form.Control
                    type="number"
                    min="0"
                    placeholder="Interest Days"
                    {...register("interest_day", {
                      required: "Interest Days is Required",
                      min: {
                        value: 0,
                        message: "Value cannot be negative",
                      },
                      valueAsNumber: true,
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.interest_day,
                    })}
                  />

                  {errors.interest_day && (
                    <span className="text-danger">
                      {errors.interest_day?.message}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <Form.Label>Interest Percent</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    min="0"
                    max="100"
                    placeholder="Interest Percent"
                    {...register("interest_percent", {
                      required: "Interest Percent is Required",
                      min: {
                        value: 0,
                        message: "Value cannot be less than 0",
                      },
                      max: {
                        value: 100,
                        message: "Value cannot be greater than 100",
                      },
                      valueAsNumber: true,
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.interest_percent,
                    })}
                  />

                  {errors.interest_percent && (
                    <span className="text-danger">
                      {errors.interest_percent?.message}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <Form.Label>Interest Amount</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    placeholder="Interest Amount"
                    {...register("interest_amount", {
                      required: "Interest Amount is Required",
                      min: {
                        value: 0,
                        message: "Amount cannot be negative",
                      },
                      valueAsNumber: true,
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.interest_amount,
                    })}
                  />
                  {errors.interest_amount && (
                    <span className="text-danger">
                      {errors.interest_amount?.message}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <Form.Label>Cab Recharge Initial Amount</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    placeholder="Cab Recharge Initial Amount"
                    {...register("cab_r_i_amount", {
                      required: "Cab Recharge Initial Amount is Required",
                      min: {
                        value: 0,
                        message: "Amount cannot be negative",
                      },
                      valueAsNumber: true,
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.cab_r_i_amount,
                    })}
                  />
                  {errors.cab_r_i_amount && (
                    <span className="text-danger">
                      {errors.cab_r_i_amount?.message}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <Form.Label>Transport Recharge Initial Amount</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    placeholder="Transport Recharge Initial Amount"
                    {...register("transport_r_i_amount", {
                      required: "Transport Recharge Initial Amount is Required",
                      min: {
                        value: 0,
                        message: "Amount cannot be negative",
                      },
                      valueAsNumber: true,
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.transport_r_i_amount,
                    })}
                  />
                  {errors.transport_r_i_amount && (
                    <span className="text-danger">
                      {errors.transport_r_i_amount?.message}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <Form.Label>Share Recharge Initial Count</Form.Label>
                  <Form.Control
                    type="number"
                    min="0"
                    placeholder="Share Recharge Initial Count"
                    {...register("share_r_i_count", {
                      required: "Share Recharge Initial Count is Required",
                      min: {
                        value: 0,
                        message: "Count cannot be negative",
                      },
                      valueAsNumber: true,
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.share_r_i_count,
                    })}
                  />

                  {errors.share_r_i_count && (
                    <span className="text-danger">
                      {errors.share_r_i_count?.message}
                    </span>
                  )}
                </div>

                {/* <div className="form-group">
                  <Form.Label>Minumum Fund Deposit </Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    placeholder="Min Fund Deposit"
                    {...register("min_fund_deposit", {
                      required: "Min Fund Deposit is Required",
                      min: {
                        value: 0,
                        message: "Amount cannot be negative",
                      },
                      valueAsNumber: true,
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.min_fund_deposit,
                    })}
                  />
                  {errors.min_fund_deposit && (
                    <span className="text-danger">
                      {errors.min_fund_deposit?.message}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <Form.Label>Minumum Driver Amount </Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    placeholder="Min Driver Amount"
                    {...register("min_driver_amount", {
                      required: "Min Driver Amount is Required",
                      min: {
                        value: 0,
                        message: "Amount cannot be negative",
                      },
                      valueAsNumber: true,
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.min_driver_amount,
                    })}
                  />
                  {errors.min_driver_amount && (
                    <span className="text-danger">
                      {errors.min_driver_amount?.message}
                    </span>
                  )}
                </div> */}
              </div>
            </div>

            <div className="form_submit_div ">
              <div className="row">
                <div className="col-lg-4 mx-auto mb-3">
                  <div className="button_group">
                    <button
                      type="button"
                      className="closebtn theme_bg"
                      onClick={() => {
                        onHide();
                      }}
                    >
                      Clear
                    </button>
                    <button
                      type="button"
                      className="addbtn"
                      onClick={handleSubmit(onSubmit)}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>
        <Successfull_Modal
          message={"App Setup update Successfully"}
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default Edit;
